import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import './FinalizeProgressLoader.scss';

/** Translation keys for rotating sub-text messages (cycle every 10 seconds) */
const IN_PROGRESS_MESSAGE_KEYS = [
  'FinalizeConfiguration.inProgressMessage1.label',
  'FinalizeConfiguration.inProgressMessage2.label',
  'FinalizeConfiguration.inProgressMessage3.label',
  'FinalizeConfiguration.inProgressMessage4.label',
  'FinalizeConfiguration.inProgressMessage5.label',
  'FinalizeConfiguration.inProgressMessage6.label',
];

const ROTATION_INTERVAL_MS = 10000;

/**
 * Component to display finalize configuration progress loader with rotating messages
 * @param {Object} props
 * @param {Function} props.t - Translation function from react-i18next
 * @param {boolean} props.isFinalizeInProgress - Whether finalize is currently in progress
 */
const FinalizeProgressLoader = ({ t, isFinalizeInProgress }) => {
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    if (!isFinalizeInProgress) {
      setMessageIndex(0);
      return;
    }
    const intervalId = setInterval(() => {
      setMessageIndex((prev) => (prev + 1) % IN_PROGRESS_MESSAGE_KEYS.length);
    }, ROTATION_INTERVAL_MS);
    return () => clearInterval(intervalId);
  }, [isFinalizeInProgress]);

  if (!isFinalizeInProgress) {
    return null;
  }

  const currentMessageKey = IN_PROGRESS_MESSAGE_KEYS[messageIndex];

  return (
    <div className="finalize-progress-container mb-2">
      <div className="card" style={{ backgroundColor: 'beige' }}>
        <div className="card-body p-3">
          <div className="d-flex align-items-center">
            <div className="spinner-border text-primary me-3" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <div>
              <h6 className="mb-0">{t("FinalizeConfiguration.creatingForm.label") || "Creating form..."}</h6>
              <small className="text-muted finalize-progress-message" key={messageIndex}>
                {t(currentMessageKey)}
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(FinalizeProgressLoader);
